import { pageConstants } from "../constants/page.constants";

const initialState = {};

export function page(state = initialState, action) {
  switch (action.type) {
    case pageConstants.PAGE_DETAIL_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case pageConstants.PAGE_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        page: action.page,
      };

    case pageConstants.PAGE_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case pageConstants.PAGE_EDIT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        current_page: action.page_info,
      };
    case pageConstants.PAGE_SET_CURRENT_PAGE:
      return {
        ...state,
        current_page: action.page,
      };
    default:
      return state;
  }
}
